"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _moment = _interopRequireDefault(require("moment"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdSpinner = _interopRequireDefault(require("cccisd-spinner"));
var _dataProcessors = _interopRequireDefault(require("./dataProcessors"));
var _DynamicForm = _interopRequireDefault(require("./components/DynamicForm.js"));
var _getEmptyFieldValue = _interopRequireDefault(require("../../helpers/getEmptyFieldValue.js"));
var _formWrapper = require("../../reducers/formWrapper.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd && window.cccisd.fortress;

/**
 * Appdefs FormWrapper component
 * This component takes a JSON form definition and transforms it into a
 * redux-form with default values, validation, and error handling.
 */
var FormWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(FormWrapper, _React$Component);
  function FormWrapper() {
    var _this;
    _classCallCheck(this, FormWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FormWrapper, [].concat(args));
    /* /////////////////////////////////////////////////////////////////////////
    // REACT LIFECYCLE METHODS ////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    //  Alter to query with filter
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, filterGroup, form, row, operation, graphql, filterGroupEmpty;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, filterGroup = _this$props.filterGroup, form = _this$props.form, row = _this$props.row;
            operation = (0, _isEmpty2["default"])(row) ? 'create' : 'edit';
            graphql = form.graphql && form.graphql[operation] ? form.graphql[operation] : {};
            filterGroupEmpty = !filterGroup || filterGroup === 0;
            if (!filterGroupEmpty) {
              graphql.requiredVariables[0].trainingOrg = filterGroup;
            }
            if ((0, _isEmpty2["default"])(graphql)) {
              _context.next = 10;
              break;
            }
            _context.next = 8;
            return _this.props.runQuery(row, graphql.gql_query, graphql.requiredVariables);
          case 8:
            _context.next = 11;
            break;
          case 10:
            _this.props.unsetLoadingState();
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.setMatchedUser({});
      _this.props.resetState();
      _this.props.unsetGraphqlData();
    });
    /* /////////////////////////////////////////////////////////////////////////
    // CLASS METHODS //////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_assertThisInitialized(_this), "getFieldTypes", function (fields) {
      var fieldTypes = {};
      fields.forEach(function (f) {
        fieldTypes[f.reduxFieldHandle] = f;
      });
      fieldTypes.formHandle = {
        handle: 'formHandle',
        reduxFieldHandle: 'formHandle',
        isRequired: true,
        type: 'pawnDataField',
        displaySettings: {
          renderAs: 'hidden',
          fieldProps: {},
          label: '',
          placeholder: ''
        }
      };
      return fieldTypes;
    });
    _defineProperty(_assertThisInitialized(_this), "getStaticValue", function (f) {
      var _f$displaySettings = f.displaySettings,
        fieldProps = _f$displaySettings.fieldProps,
        renderAs = _f$displaySettings.renderAs;
      if (renderAs.includes('date')) {
        return _this.processDate(fieldProps.initialValue);
      }
      if (['toggle', 'checkbox'].includes(renderAs)) {
        return _this.processBool(fieldProps.initialValue);
      }
      return fieldProps.initialValue;
    });
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
        var _this$props2, form, matchedUser, routes, row, userAvailable;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, form = _this$props2.form, matchedUser = _this$props2.matchedUser, routes = _this$props2.routes, row = _this$props2.row, userAvailable = _this$props2.userAvailable;
              if (!(form.isUserForm && !userAvailable)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _context2.next = 5;
              return _this.props.handleFormSubmit({
                row: row,
                values: values,
                routes: routes,
                fieldTypes: form.fields,
                hasMatchedUser: form.isUserForm ? !(0, _isEmpty2["default"])(matchedUser) : false
              });
            case 5:
              _this.props.closeModal();
              _this.props.afterFormSubmit();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "processBool", function (value) {
      if (value === 'true') {
        return true;
      }
      if (value === 'false') {
        return false;
      }
      return value;
    });
    _defineProperty(_assertThisInitialized(_this), "processCreateValue", function (f) {
      var graphqlData = _this.props.graphqlData;
      if (f.graphql && f.graphql.create && f.graphql.create.valuePath) {
        if (f.displaySettings.renderAs.includes('date')) {
          return _this.processDate((0, _get2["default"])(graphqlData, f.graphql.create.valuePath));
        }
        var gqlValue = (0, _get2["default"])(graphqlData, f.graphql.create.valuePath);
        return !(0, _isNull2["default"])(gqlValue) ? _this.processGqlData(gqlValue, f.graphql.create) : (0, _getEmptyFieldValue["default"])(f);
      }
      if (!(0, _isEmpty2["default"])(f.displaySettings.fieldProps) && f.displaySettings.fieldProps.initialValue) {
        return _this.getStaticValue(f);
      }
      if (f.type === 'userDataField') {
        return (0, _get2["default"])(Fortress, f.displaySettings.fieldProps.valuePath);
      }
      return (0, _getEmptyFieldValue["default"])(f);
    });
    _defineProperty(_assertThisInitialized(_this), "processDate", function (value) {
      return (0, _moment["default"])(value).format('YYYY-MM-DD HH:mm:ss');
    });
    _defineProperty(_assertThisInitialized(_this), "processEditValue", function (f) {
      if (f.graphql && f.graphql.edit && f.graphql.edit.valuePath) {
        if (f.displaySettings.renderAs.includes('date')) {
          var initialValue = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.valuePath);
          if (initialValue) {
            initialValue = _this.processDate(initialValue);
          }
          return initialValue;
        }
        if (f.displaySettings.renderAs === 'table') {
          if (f.displaySettings.fieldProps.selectionType === 'multi') {
            // multi select table
            var _pawnCollection = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.optionsPath);
            var _stringRows = [];
            if (_pawnCollection && _pawnCollection.length) {
              _pawnCollection.forEach(function (pc) {
                _stringRows.push((0, _get2["default"])(pc, f.graphql.edit.valuePath));
              });
            }
            return (0, _isEmpty2["default"])(_stringRows) ? null : _stringRows;
          }

          // single select table
          var pawnCollection = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.valuePath);
          if (f.graphql.edit.skipPawnCollectionProcessing) {
            return pawnCollection;
          }
          var stringRows = [];
          if (pawnCollection && pawnCollection.length) {
            pawnCollection.forEach(function (pc) {
              stringRows.push(pc.pawn.pawnId);
            });
          }
          return (0, _isEmpty2["default"])(stringRows) ? null : stringRows;
        }
        if ((f.displaySettings.renderAs === 'select' || f.displaySettings.renderAs === 'enum') && f.displaySettings.selectionType === 'multi') {
          var _gqlValue = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.valuePath);
          _gqlValue = typeof _gqlValue === 'string' && _gqlValue !== '' ? JSON.parse(_gqlValue) : _gqlValue || [];
          return 'fieldSettings' in f.graphql.edit && 'valueFieldPath' in f.graphql.edit.fieldSettings ? _gqlValue.map(function (d) {
            return (0, _get2["default"])(d, f.graphql.edit.fieldSettings.valueFieldPath);
          }) : _gqlValue;
        }
        var gqlValue = (0, _get2["default"])(_this.props.graphqlData, f.graphql.edit.valuePath);
        return !(0, _isNull2["default"])(gqlValue) ? _this.processGqlData(gqlValue, f.graphql.edit) : (0, _getEmptyFieldValue["default"])(f);
      }
      if (!(0, _isEmpty2["default"])(f.displaySettings.fieldProps) && f.displaySettings.fieldProps.initialValue) {
        // editing & static initial value
        return _this.getStaticValue(f);
      }
      if (f.type === 'userDataField') {
        return (0, _get2["default"])(Fortress, f.displaySettings.fieldProps.valuePath);
      }
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "processGqlData", function (data, settings) {
      if ('dataProcessor' in settings) {
        return _dataProcessors["default"][settings.dataProcessor](data);
      }
      return data;
    });
    _defineProperty(_assertThisInitialized(_this), "processInitialValue", function (f) {
      return (0, _isEmpty2["default"])(_this.props.row) ? _this.processCreateValue(f) : _this.processEditValue(f);
    });
    _defineProperty(_assertThisInitialized(_this), "renderForm", function () {
      var _this$props3 = _this.props,
        checkingUser = _this$props3.checkingUser,
        form = _this$props3.form,
        graphqlData = _this$props3.graphqlData,
        row = _this$props3.row;
      var sortedFields = _this.sortFields(form.fields);
      var reduxFormFields = [];
      var initialValues = {};
      sortedFields.forEach(function (f) {
        reduxFormFields.push(f.reduxFieldHandle);
        initialValues[f.reduxFieldHandle] = _this.processInitialValue(f);
      });
      reduxFormFields.push('formHandle');
      initialValues.formHandle = form.handle;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, checkingUser && /*#__PURE__*/_react["default"].createElement(_cccisdSpinner["default"], {
        options: {
          scale: 0.6,
          lines: 8,
          top: 0,
          left: '100%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_DynamicForm["default"], {
        fields: reduxFormFields,
        fieldTypes: _this.getFieldTypes(sortedFields),
        onSubmit: _this.handleSubmit,
        initialValues: initialValues,
        loadedData: graphqlData,
        operation: (0, _isEmpty2["default"])(row) ? 'create' : 'edit',
        row: (0, _isEmpty2["default"])(row) ? {} : row,
        shouldCheckUser: !!form.isUserForm,
        checkUserSettings: !!form.isUserForm && 'userCheckSettings' in form ? form.userCheckSettings : {}
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "sortFields", function (fields) {
      // sort fields
      return (0, _sortBy2["default"])(fields, [function (f) {
        return f.order;
      }]);
    });
    return _this;
  }
  _createClass(FormWrapper, [{
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      if (this.props.loading) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].loading
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true,
          type: "inline"
        }));
      }
      return this.renderForm();
    }
  }]);
  return FormWrapper;
}(_react["default"].Component);
_defineProperty(FormWrapper, "propTypes", {
  /** Optional custom callback for after the form has been submitted */
  afterFormSubmit: _propTypes["default"].func,
  checkingUser: _propTypes["default"].bool,
  /** Function that will close the modal holding the form */
  closeModal: _propTypes["default"].func,
  /** Filter by Group Id */
  filterGroup: _propTypes["default"].number,
  /** JSON definition of the form */
  form: _propTypes["default"].object,
  /** The graphql data from the server */
  graphqlData: _propTypes["default"].object,
  /** Reducer handleSubmit */
  handleFormSubmit: _propTypes["default"].func,
  loading: _propTypes["default"].bool,
  /** The userCheck user object */
  matchedUser: _propTypes["default"].object,
  resetState: _propTypes["default"].func,
  /** JSON for CRUD and data routes */
  routes: _propTypes["default"].object,
  /** The row for form edits */
  row: _propTypes["default"].object,
  /** Run a query to populate the graphqlData object */
  runQuery: _propTypes["default"].func,
  /** The userCheck set user function */
  setMatchedUser: _propTypes["default"].func,
  /** Erase current graphql data */
  unsetGraphqlData: _propTypes["default"].func,
  unsetLoadingState: _propTypes["default"].func,
  /** Is the user available? */
  userAvailable: _propTypes["default"].bool
});
_defineProperty(FormWrapper, "defaultProps", {
  routes: {},
  afterFormSubmit: function afterFormSubmit() {},
  form: {},
  row: {}
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    checkingUser: state.appdefs.formWrapper.checkingUser,
    graphqlData: state.appdefs.formWrapper.graphqlData,
    loading: state.appdefs.formWrapper.loading,
    matchedUser: state.appdefs.formWrapper.matchedUser,
    userAvailable: state.appdefs.formWrapper.userAvailable
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  handleFormSubmit: _formWrapper.handleFormSubmit,
  resetState: _formWrapper.resetState,
  runQuery: _formWrapper.runQuery,
  setMatchedUser: _formWrapper.setMatchedUser,
  unsetGraphqlData: _formWrapper.unsetGraphqlData,
  unsetLoadingState: _formWrapper.unsetLoadingState
})(FormWrapper);